import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSquareFrame24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M5.125 8.66667V5.95833C5.125 5.4981 5.4981 5.125 5.95833 5.125H8.66667M5.125 15.3333V18.0417C5.125 18.5019 5.4981 18.875 5.95833 18.875H8.66667M15.3333 5.125H18.0417C18.5019 5.125 18.875 5.4981 18.875 5.95833V8.66667M18.875 15.3333V18.0417C18.875 18.5019 18.5019 18.875 18.0417 18.875H15.3333M10.125 14.7083H13.875C14.3352 14.7083 14.7083 14.3352 14.7083 13.875V10.125C14.7083 9.66477 14.3352 9.29167 13.875 9.29167H10.125C9.66477 9.29167 9.29167 9.66477 9.29167 10.125V13.875C9.29167 14.3352 9.66477 14.7083 10.125 14.7083Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoSquareFrame24;